var _desc, _g, _defs;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgMiScores(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 15,
    viewBox: "0 0 16 15",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _desc || (_desc = /*#__PURE__*/React.createElement("desc", null, "Created using Figma")), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "mi-scores_svg__mi-scores_svg__Canvas",
    transform: "translate(9960 1848)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "mi-scores_svg__mi-scores_svg__Group_6"
  }, /*#__PURE__*/React.createElement("g", {
    id: "mi-scores_svg__mi-scores_svg__Oval"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#mi-scores_svg__mi-scores_svg__path0_fill",
    transform: "translate(-9951.86 -1842.46)"
  })), /*#__PURE__*/React.createElement("g", {
    id: "mi-scores_svg__mi-scores_svg__Shape"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#mi-scores_svg__mi-scores_svg__path1_fill",
    transform: "translate(-9954.7 -1845.29)"
  })), /*#__PURE__*/React.createElement("g", {
    id: "mi-scores_svg__mi-scores_svg__Shape"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#mi-scores_svg__mi-scores_svg__path2_fill",
    transform: "translate(-9957.39 -1848)"
  })), /*#__PURE__*/React.createElement("g", {
    id: "mi-scores_svg__mi-scores_svg__Shape"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#mi-scores_svg__mi-scores_svg__path3_fill",
    transform: "translate(-9959.21 -1840.13)"
  }))))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("path", {
    id: "mi-scores_svg__mi-scores_svg__path0_fill",
    fillRule: "evenodd",
    d: "M 0.910228 1.82333C 1.41293 1.82333 1.82046 1.41517 1.82046 0.911666C 1.82046 0.408167 1.41293 0 0.910228 0C 0.407523 0 0 0.408167 0 0.911666C 0 1.41517 0.407523 1.82333 0.910228 1.82333Z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "mi-scores_svg__mi-scores_svg__path1_fill",
    fillRule: "evenodd",
    d: "M 7.49934 3.74061C 7.49382 2.35423 6.72615 1.08365 5.50249 0.435581C 4.27882 -0.212489 2.79821 -0.132632 1.6511 0.643307C 0.503996 1.41925 -0.122996 2.76504 0.0201639 4.144L 1.31301 4.0835C 1.16149 3.03322 1.69704 2.00347 2.64317 1.52586C 3.5893 1.04825 4.73432 1.22966 5.48709 1.97642C 6.23985 2.72318 6.43194 3.86821 5.96418 4.82037C 5.49642 5.77253 4.47347 6.31878 3.42345 6.1771L 3.35498 7.46795C 4.41097 7.57991 5.46483 7.23817 6.25493 6.52757C 7.04502 5.81698 7.49725 4.80417 7.49934 3.74061Z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "mi-scores_svg__mi-scores_svg__path2_fill",
    fillRule: "evenodd",
    d: "M 6.44409 0C 2.88512 0 0 2.88968 0 6.45427C 0 6.6358 0 6.81733 0.0241653 6.99482L 1.31298 6.93431C 1.31298 6.77699 1.28882 6.61563 1.28882 6.45427C 1.28882 3.6026 3.59691 1.29085 6.44409 1.29085C 9.29127 1.29085 11.5994 3.6026 11.5994 6.45427C 11.5994 9.30595 9.29127 11.6177 6.44409 11.6177C 6.28702 11.6177 6.12994 11.6177 5.97287 11.5975L 5.9044 12.8884C 6.08161 12.8884 6.26285 12.9126 6.44409 12.9126C 10.0042 12.9126 12.8902 10.022 12.8902 6.45629C 12.8902 2.89058 10.0042 0 6.44409 0Z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "mi-scores_svg__mi-scores_svg__path3_fill",
    fillRule: "evenodd",
    d: "M 0 5.0424L 1.81643 5.32478L 2.05003 6.97465L 5.06667 3.89677L 6.6213 5.0424L 6.8549 0L 1.81643 0.286408L 3.42745 1.8435L 0 5.0424Z"
  }))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgMiScores);
export default __webpack_public_path__ + "static/media/mi-scores.a12893f906cef9c7fe6ddc1677fc2729.svg";
export { ForwardRef as ReactComponent };